<template>
  <div id="navbar" class="container">
    <nav class="navbar navbar-expand-xl navbar-light bg-light">
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li v-for="link in links" :key="link.name" class="nav-item">
            <router-link :to="{ name: link.name }" class="nav-link">{{ link.label }}</router-link>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'SiteNavigation',
  data() {
    return {
      links: [
        {name: 'HomeView', label: 'Home'},
        {name: 'EventsView', label: 'Car Shows'},
        {name: 'ContactView', label: 'Contact Us'}
      ]
    }
  }
}
</script>

<style scoped>
.navbar {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom: 1px solid #ccc;
}

.container {
  padding: 0;
}
</style>